import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const ZoomFit = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M25 6C25 5.44772 25.4477 5 26 5L30 5C32.7614 5 35 7.23831 35 9.9998V14C35 14.5523 34.5523 15 34 15C33.4477 15 33 14.5523 33 14V9.9998C33 8.34301 31.6569 7 30 7H26C25.4477 7 25 6.55228 25 6ZM5 10C5 7.23864 7.23831 5 9.9998 5H14C14.5523 5 15 5.44772 15 6C15 6.55229 14.5523 7 14 7H9.9998C8.34301 7 7 8.34308 7 10V14C7 14.5523 6.55229 15 6 15C5.44772 15 5 14.5523 5 14V10ZM20 16C17.7909 16 16 17.7909 16 20C16 22.2091 17.7909 24 20 24C22.2091 24 24 22.2091 24 20C24 17.7909 22.2091 16 20 16ZM14 20C14 16.6863 16.6863 14 20 14C23.3137 14 26 16.6863 26 20C26 23.3137 23.3137 26 20 26C16.6863 26 14 23.3137 14 20ZM6 25C6.55228 25 7 25.4477 7 26V30.0002C7 31.657 8.34308 33 10 33H14C14.5523 33 15 33.4477 15 34C15 34.5523 14.5523 35 14 35H10C7.23864 35 5 32.7617 5 30.0002L5 26C5 25.4477 5.44772 25 6 25ZM34 25C34.5523 25 35 25.4477 35 26L35 30C35 32.7614 32.7617 35 30.0002 35H26C25.4477 35 25 34.5523 25 34C25 33.4477 25.4477 33 26 33H30.0002C31.657 33 33 31.6569 33 30L33 26C33 25.4477 33.4477 25 34 25Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default ZoomFit;
